<div class="row">
  <div class="col-sm-6">
    <div style="text-align: right;" *ngIf="WriteAction">
      <button mat-raised-button color="primary" (click)="add()">
        Add
      </button>
    </div>
    <table mat-table matSort [dataSource]="dataSource" style="width: 100%;">
      <ng-container matColumnDef="phoneType">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Phone Type </th>
        <td mat-cell *matCellDef="let element">
          {{element.phoneType}}
        </td>
      </ng-container>
      <ng-container matColumnDef="phone">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Phone </th>
        <td mat-cell *matCellDef="let element">
          {{element.phone}}
        </td>
      </ng-container>
      <ng-container matColumnDef="ext">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Extension </th>
        <td mat-cell *matCellDef="let element">
          {{element.extension}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row [ngClass]="{'row_select': row.personPhoneId === this.personPhone.personPhoneId }"
        *matRowDef="let row; columns: displayedColumns;" (click)="edit(row)"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
  <div class="col-sm-6" *ngIf="isShown" [ngClass]="{disabledDiv: !WriteAction}">
    <div [formGroup]="phoneFormGroup">
      <div style="text-align: right;" *ngIf="WriteAction">
        <button mat-raised-button color="primary" [disabled]="!phoneFormGroup.valid" (click)="onSubmit()">
          {{this.personPhone && this.personPhone.personPhoneId !== null ? 'Update': 'Save'}}
        </button>
        &nbsp;
        <button mat-raised-button (click)="cancel()">
          Cancel
        </button>
        &nbsp;
        <button color="warn" *ngIf="this.personPhone && this.personPhone.personPhoneId !== null"
          (click)="delete(this.personPhone.personPhoneId)" mat-raised-button (click)="cancel()">
          Delete
        </button>
      </div>
      <br>
      <mat-divider></mat-divider>
      <br>
      <div class="col-sm-6">
          <mat-slide-toggle [checked]="isInternationlPhone" (change)="toggleChangeEvent($event)">International Phone Number?</mat-slide-toggle>
        </div>
      <div class="row" *ngIf="!isInternationlPhone">
        <div class="col-sm-4">
          <mat-form-field [hidden]="true">
            <input matInput formControlName="personPhoneId">
          </mat-form-field>
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Phone Type</mat-label>
            <mat-select required formControlName="phoneTypeId">
              <mat-option>--SELECT--</mat-option>             
              <ng-container *ngFor="let item of phoneTypeList">
                <mat-option *ngIf="evalBind(item,personPhone.phoneTypeId)" [value]="item.id">
                    {{item.description}}
                </mat-option>
              </ng-container> 
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Phone</mat-label>
            <input matInput required placeholder="(xxx) xxx-xxxx" mask="(000) 000-0000" [dropSpecialCharacters]="false"
              maxlength="50" formControlName="phone">
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Extension</mat-label>
            <input matInput placeholder="Extension" maxlength="10" formControlName="extension">
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="isInternationlPhone">
        <div class="col-sm-4">
          <mat-form-field [hidden]="true">
            <input matInput formControlName="personPhoneId">
          </mat-form-field>
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Phone Type</mat-label>
            <mat-select required formControlName="phoneTypeId">
              <mat-option>--SELECT--</mat-option>             
              <ng-container *ngFor="let item of phoneTypeList">
                <mat-option *ngIf="evalBind(item,personPhone.phoneTypeId)" [value]="item.id">
                    {{item.description}}
                </mat-option>
              </ng-container> 
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Phone</mat-label>
            <input matInput requiredmaxlength="50" formControlName="phone">
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Extension</mat-label>
            <input matInput placeholder="Extension" maxlength="10" formControlName="extension">
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>